export default __webpack_public_path__ + "static/media/perfil.2ed7041a.png";